import Grid from '@mui/material/Grid2'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  CameraDetailsDTO,
  ParkingEventDetailsDTO,
} from '../../../apis/parkingEvents/dto'
import { MoovyScrollToTop, ValueOrElse } from '../../../components'
import { prettyFullTimestamp } from '../../../utils/datetimeUtils'
import { DividerRow, RowLabel, RowValue } from './detailsGridComponents'

interface ParkingDetailsCameraTabProps {
  parkingDetails?: ParkingEventDetailsDTO
  cameraRole: 'ENTRY' | 'EXIT'
}

const ParkingDetailsCameraTab = (props: ParkingDetailsCameraTabProps) => {
  const { parkingDetails, cameraRole } = props
  const intl = useIntl()
  if (!parkingDetails) {
    return null
  }
  const camera: CameraDetailsDTO | null =
    (cameraRole === 'ENTRY'
      ? parkingDetails.entryCamera
      : parkingDetails.exitCamera) ?? null
  const imageUrl = camera?.image
  return (
    <Grid container direction="row" spacing={1} paddingTop={2}>
      <MoovyScrollToTop />
      <RowLabel formattedMessageId="page.parkingDetails.camera.name" />
      <RowValue>
        <ValueOrElse>{camera?.name}</ValueOrElse>
      </RowValue>
      <DividerRow />
      <RowLabel formattedMessageId="page.parkingDetails.camera.id" />
      <RowValue>
        <ValueOrElse>{camera?.id}</ValueOrElse>
      </RowValue>
      <DividerRow />
      <RowLabel formattedMessageId="page.parkingDetails.camera.lane" />
      <RowValue>
        <ValueOrElse>{camera?.lane}</ValueOrElse>
      </RowValue>
      <DividerRow />
      <RowLabel formattedMessageId="common.text.timestamp" />
      <RowValue>
        <ValueOrElse>
          {prettyFullTimestamp(
            intl,
            cameraRole === 'ENTRY'
              ? parkingDetails.startTime
              : parkingDetails.endTime,
          )}
        </ValueOrElse>
      </RowValue>
      <DividerRow />
      <RowLabel formattedMessageId="common.text.licensePlate" />
      <RowValue>
        <ValueOrElse>{parkingDetails.licensePlate}</ValueOrElse>
      </RowValue>
      <DividerRow />
      <RowLabel
        formattedMessageId="page.parkingDetails.camera.photo"
        omitColon
      />
      {imageUrl ? (
        <>
          <img width="100%" src={imageUrl} />
        </>
      ) : (
        <RowValue>
          <FormattedMessage id="page.parkingDetails.camera.imageMissing" />
        </RowValue>
      )}
    </Grid>
  )
}

export default ParkingDetailsCameraTab
